<div class="d-flex flex-column flex-lg-row justify-content-lg-end">
  <span class="footer__label mr-lg-4" [attr.data-qa]="testIdPrefix + '-current-dates-selected'">
    {{ startDate | date : dateFormat }}
    {{ endDate ? '-' : '' }}
    {{ endDate | date : dateFormat }}
  </span>
  <div class="d-flex flex-row mb-2">
    <rx-button
      class="mr-2 footer__button"
      [flexible]="true"
      buttonClass="secondary"
      (click)="clickReset.emit()"
      [attr.data-qa]="testIdPrefix + '-reset-button'"
      >{{ resetText }}</rx-button
    >
    <rx-button
      class="footer__button"
      [flexible]="true"
      buttonClass="primary"
      (click)="clickApply.emit()"
      [attr.data-qa]="testIdPrefix + '-apply-button'"
      [disabled]="!startDate && !endDate"
      >{{ applyText }}</rx-button
    >
  </div>
</div>
